import { render, staticRenderFns } from "./UpdateLecturerModal.vue?vue&type=template&id=3437e3e2&"
import script from "./UpdateLecturerModal.vue?vue&type=script&lang=js&"
export * from "./UpdateLecturerModal.vue?vue&type=script&lang=js&"
import style0 from "./UpdateLecturerModal.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports